var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _ellipse, _ellipse2, _path9, _path0, _path1, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 1400,
    viewBox: "0 0 1400 1400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1056.5 1136.5C974.1 1172.1 830.5 1159.67 769 1149L885 1250.5C971 1270.1 1063.5 1242.33 1099 1226L1056.5 1136.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M983 971.5C807 995.5 693.167 987 585 971.5L665.5 1048.5C797.9 1074.9 966.5 1071 1024.5 1057L983 971.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M909 800.5C724 816.5 541.333 790.167 402.5 792L461.5 855.5C779.5 895.5 848.833 876.667 949.5 873L909 800.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 771L998 1364.5",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.43 1269.84L780.069 467.664",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87 595.5C158.833 525.833 358 453 523.5 662",
    stroke: "white",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M292.306 634.16C204.467 603.983 154.76 664.804 136.909 707.839C134.464 713.734 137.682 720.26 143.656 722.505L194.687 741.682C202.693 744.69 211.186 738.526 211.93 730.006C216.909 672.968 256.372 659.065 285.53 659.525C293.081 659.645 300 653.977 300 646.425V645.167C300 640.239 296.966 635.761 292.306 634.16Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M629.41 397.427C590.168 310.215 635.676 248.927 687.598 229.595C693.018 227.577 698.909 230.329 701.412 235.543L733.212 301.778C736.917 309.496 731.519 318.506 723.054 319.789C666.35 328.382 652.79 361.552 654.73 388.369C655.268 395.798 650.441 403.117 643.035 403.916L641.306 404.103C636.314 404.642 631.47 402.005 629.41 397.427Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 470.5,
    r: 16.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.761,
    cy: 1229.64,
    r: 16.5,
    transform: "rotate(-9.50847 378.761 1229.64)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1287.5,
    cy: 898.5,
    r: 16.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 474.5,
    r: 8.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.79,
    cy: 1225.98,
    r: 8.5,
    transform: "rotate(-9.50847 424.79 1225.98)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.5,
    cy: 243.5,
    r: 8.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.5,
    cy: 291.5,
    r: 8.5,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253,
    cy: 52.5,
    rx: 19,
    ry: 21.5,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.659,
    cy: 200.737,
    rx: 20.6803,
    ry: 26.7112,
    transform: "rotate(-37.4463 308.659 200.737)",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6037 227.643C72.2691 212.86 78.839 188.523 84.0363 175.272C84.762 173.421 86.8468 172.554 88.705 173.259L125.877 187.358C127.476 187.965 128.457 189.583 128.254 191.282L123.459 231.564C123.213 233.632 121.319 235.097 119.255 234.815L81.3214 229.627C80.1317 229.464 79.0767 228.746 78.6037 227.643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 18.6259,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M574.563 19.7139C563.655 27.8036 558.098 48.351 556.254 60.2277C555.996 61.886 557.148 63.4054 558.803 63.6815L591.916 69.2047C593.34 69.4424 594.744 68.6791 595.319 67.354L608.952 35.9294C609.652 34.316 608.893 32.4422 607.268 31.7704L577.39 19.4219C576.453 19.0346 575.378 19.1098 574.563 19.7139Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 15.7277,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M179 302.5C94.16 357.531 132.183 425.768 165.394 456.89C168.056 459.384 172.082 459.53 175.062 457.427L177.938 455.397C182.398 452.249 182.434 445.642 178.638 441.719C163.62 426.199 162.065 408.394 163.5 400.5C166.7 360.09 216.167 347.996 242 353.5C329.896 372.228 365.21 442.643 382.005 485.632C383.672 489.899 388.53 491.974 392.735 490.155L398.506 487.66C401.52 486.356 403.466 483.371 402.962 480.126C394.335 424.591 286.201 232.964 179 302.5Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.999,
    cy: 949.5,
    rx: 11,
    ry: 40.5,
    transform: "rotate(2.75974 109.999 949.5)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.937,
    cy: 1049.98,
    rx: 11,
    ry: 40.5,
    transform: "rotate(2.75974 105.937 1049.98)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.6579,
    cy: 999.404,
    rx: 11,
    ry: 30.812,
    transform: "rotate(92.7597 65.6579 999.404)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.305,
    cy: 1002.47,
    rx: 11,
    ry: 30.812,
    transform: "rotate(92.7597 149.305 1002.47)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 910.1,
    cy: 147.316,
    rx: 9.17548,
    ry: 33.7825,
    transform: "rotate(2.75974 910.1 147.316)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 906.711,
    cy: 231.132,
    rx: 9.17548,
    ry: 33.7825,
    transform: "rotate(2.75974 906.711 231.132)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 873.113,
    cy: 188.942,
    rx: 9.17548,
    ry: 25.7014,
    transform: "rotate(92.7597 873.113 188.942)",
    fill: "white"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 942.887,
    cy: 191.501,
    rx: 9.17548,
    ry: 25.7014,
    transform: "rotate(92.7597 942.887 191.501)",
    fill: "white"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1079.1,
    cy: 488.185,
    rx: 9.17548,
    ry: 33.7825,
    transform: "rotate(2.75974 1079.1 488.185)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1075.71,
    cy: 572.001,
    rx: 9.17548,
    ry: 33.7825,
    transform: "rotate(2.75974 1075.71 572.001)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1042.11,
    cy: 529.811,
    rx: 9.17548,
    ry: 25.7014,
    transform: "rotate(92.7597 1042.11 529.811)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1111.89,
    cy: 532.37,
    rx: 9.17548,
    ry: 25.7014,
    transform: "rotate(92.7597 1111.89 532.37)",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1286.01,
    cy: 364,
    rx: 12,
    ry: 124,
    transform: "rotate(1.69038 1286.01 364)",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1290.11,
    cy: 373.868,
    rx: 12,
    ry: 85.2541,
    transform: "rotate(98.0827 1290.11 373.868)",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1289.58,
    cy: 363.958,
    rx: 12,
    ry: 85.2541,
    transform: "rotate(45.8885 1289.58 363.958)",
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 85.2541,
    rx: 12,
    ry: 85.2541,
    transform: "matrix(-0.696057 0.717986 0.717986 0.696057 1236.71 306)",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M431.5 56.5C457.833 74.1667 497 145.6 443 290C434.243 313.402 432.571 365.141 486.747 400.543C497.625 407.651 504.869 419.503 506.084 432.441C510.429 478.704 534.841 557.412 610.5 619.5",
    stroke: "white",
    strokeWidth: 49,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M428 612C372.166 668.333 290.3 781 409.5 781C528.7 781 677.5 651 737 586C774 538.167 822.7 440.8 721.5 434C620.3 427.2 525.333 510.167 490.5 552.5",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M821 582.5C797 592.5 756 586.667 738.5 582.5L628.5 687.5C708.5 696.7 839.5 707.167 879 707L821 582.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.5 1305.5C1063.9 1327.1 998.333 1337.83 964 1331C1004.4 1405 1047.67 1387.83 1070 1379.5C1146 1346 1137 1297.67 1126 1264.5L1070 1233.5L1097.5 1305.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMarketing);
export default __webpack_public_path__ + "static/media/event-marketing.86a077ec0c09602398ce6a5e4024e4c6.svg";
export { ForwardRef as ReactComponent };